import React from "react";
import "./Gallery.css";
import img1 from "../../../Images/gallery1.jpg";
import img2 from "../../../Images/gallery2.jpg";
import img3 from "../../../Images/gallery3.jpg";
import img4 from "../../../Images/gallery4.jpg";
import img5 from "../../../Images/gallery5.jpg";
import img6 from "../../../Images/gallery6.jpg";
import img7 from "../../../Images/gallery.7.jpg";
import img8 from "../../../Images/gallery.8.jpg";
import img9 from "../../../Images/gallery9.jpg";
import img10 from "../../../Images/gallery10.jpg";
import img11 from "../../../Images/gallery11.jpg";
import img12 from "../../../Images/gallery12.jpg";
import img13 from "../../../Images/gallery13.jpg";
import img14 from "../../../Images/gallery14.jpg";




const Gallery = () => {
  const images = [img1, img2, img3, img4, img5, img6, img7, img8, img9, img10, img11, img12, img13, img14,];

  return (
    <div className="gallery-container">
      <h2 className="gallery-title">Our Gallery</h2>
      <div className="gallery-grid">
        {images.map((image, index) => (
          <div key={index} className="gallery-item">
            <img src={image} alt={`Gallery ${index + 1}`} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Gallery;
